import React from "react";
import { Link } from "react-router-dom";
import {
  Flex,
  Text,
  IconButton,
  useColorMode,
  useColorModeValue,
} from "@chakra-ui/react";
import { LuMoon, LuSun } from "react-icons/lu";
import { FiMenu } from "react-icons/fi";

function Header({ onToggleSidebar }) {
  const { toggleColorMode, colorMode } = useColorMode();
  const bgColor = useColorModeValue("white", "gray.800");
  const textColor = useColorModeValue("black", "white");

  return (
    <Flex
      as="header"
      bg={bgColor}
      p={4}
      justify="space-between"
      align="center"
      color={textColor}
    >
      <Flex align="center">
        <IconButton
          aria-label="Toggle Menu"
          icon={<FiMenu />}
          variant="ghost"
          onClick={onToggleSidebar}
          mr={3}
        />
        <Link to="/">
          <Text size="xs">SubjectiveOne</Text>
        </Link>
      </Flex>

      <IconButton onClick={toggleColorMode} variant="outline" size="sm" rounded="full">
        {colorMode === "light" ? <LuSun /> : <LuMoon />}
      </IconButton>
    </Flex>
  );
}

export default Header;
